module.exports = __webpack_public_path__ + "img/doc.a2269a7c.png";